import { put, takeLatest, call } from "redux-saga/effects";
import { showNotification } from "../../utils/CommonFunctions";
import ACTIONS from "./DoorActionTypes";
import AppUrl from "../../config/AppUrl";
import axios from "axios";

const getAllDoorsRequest = (params) => {
  return axios({
    method: "GET",
    url: `${AppUrl.WORKSPACE}/${params?.space_id}/locks`,
    params: params,
  });
};

function* getAllDoors(action) {
  try {
    let resources = yield call(getAllDoorsRequest, action.payload);
    let _data = resources?.data;
    _data.space_id = action.payload?.space_id;

    if (_data?.meta?.success !== true || _data?.meta?.status !== 200) {
      showNotification("error", _data?.meta?.message);
      yield put({
        type: ACTIONS.FETCH_ALL_DOOR_FAILURE,
        payload: _data,
      });
    } else {
      yield put({
        type: ACTIONS.FETCH_ALL_DOOR_SUCCESS,
        payload: _data,
      });
    }
  } catch (error) {
    console.log("get all door error", error);
  }
}

// ACTION WATCHER
export default function* doorSaga() {
  yield takeLatest(ACTIONS.FETCH_ALL_DOOR, getAllDoors);
}
